import { render, staticRenderFns } from "./PermitLicensesSidebar.vue?vue&type=template&id=fd51f9e6&"
import script from "./PermitLicensesSidebar.vue?vue&type=script&lang=js&"
export * from "./PermitLicensesSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd51f9e6')) {
      api.createRecord('fd51f9e6', component.options)
    } else {
      api.reload('fd51f9e6', component.options)
    }
    module.hot.accept("./PermitLicensesSidebar.vue?vue&type=template&id=fd51f9e6&", function () {
      api.rerender('fd51f9e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/company/components/PermitLicensesSidebar.vue"
export default component.exports